import t from"./transitionEmit.js";function i(i=!0,s){const n=this,{params:a}=n;n.animating=!1,a.cssMode||(n.setTransition(0),t({swiper:n,runCallbacks:i,direction:s,step:"End"}))}export{i as default};
//# sourceMappingURL=transitionEnd.js.map
